import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AlertController, ToastController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { UserService } from "src/app/_services/user.service";
import { Product } from "../_model/product.model";
import { CartService } from "../_services/cart.service";

@Component({
  selector: "app-product-tile",
  templateUrl: "./product-tile.component.html",
  styleUrls: ["./product-tile.component.scss"],
})
export class ProductTileComponent implements OnInit {
  @Input()
  product: Product;

  @Input()
  userServ: UserService;

  @Input()
  showEditButton = false;

  @Input()
  showProviderName = false;

  @Output()
  showCart = new EventEmitter<number>();

  @Output()
  editProduct = new EventEmitter<number>();

  idProvider: number;
  canEdit: boolean;

  constructor(
    public cartServ: CartService,
    public transServ: TranslateService,
    private toastController: ToastController,
  ) {}

  async ngOnInit() {
    this.canEdit = await this.userServ.permissionEditCompanyAsync(
      this.product.companyProvider.id,
      ['market.product.add'],
      ['market.edit.only-my-company']
    );

    this.idProvider = this.product.companyProvider.id;
  }

  async addToCart() {
    const alertController = new AlertController();
    if (this.cartServ.canAddToCart(this.idProvider)) {
      this.cartServ.addProduct(this.product);
      this.showCart.emit(this.idProvider);
      const toast = await this.toastController.create({
        message: this.transServ.instant("MARKET.ADDED_TO_CHART"),
        duration: 1000,
        color: "dark",
      });
      toast.present();
    } else {
      const alert = await alertController.create({
        header: this.transServ.instant("MARKET.ERROR.CANNOT_BE_ADDED_TO_CART"),
        message: this.transServ.instant("MARKET.ERROR.ALREADY_PRODUCTS"),
        buttons: [
          {
            text: "Ok",
          },
        ],
      });
      await alert.present();
    }
  }
  
  onEditProductClick(): void {
    if (this.showEditButton) {
      this.editProduct.emit(this.product.id);
    }
  }
}
